import { render } from "./ImToken.vue?vue&type=template&id=9be17e7e&scoped=true"
import script from "./ImToken.vue?vue&type=script&lang=js"
export * from "./ImToken.vue?vue&type=script&lang=js"

import "./ImToken.vue?vue&type=style&index=0&id=9be17e7e&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9be17e7e"]])

export default __exports__